import { render, staticRenderFns } from "./EditPercepcionCargasFamiliaHijos.vue?vue&type=template&id=218508b3&scoped=true&"
import script from "./EditPercepcionCargasFamiliaHijos.vue?vue&type=script&lang=js&"
export * from "./EditPercepcionCargasFamiliaHijos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218508b3",
  null
  
)

export default component.exports